import * as vp from 'vopay';
import { RouteComponentProps, Link, withRouter } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useBranding } from '@/providers/Branding.provider';
import useFetchLoginPageBranding from '@/hooks/useApi/useFetchLoginPageBranding';
import styles from './Login.module.scss';
import LoginRoutes from '@/components/LoginPages/Routes';

const { Box, Icon } = vp;

const Login: React.FunctionComponent<RouteComponentProps> = (_props: RouteComponentProps) => {
  const { logo, setBrandingValues } = useBranding();
  const [brandingLoaded, setBrandingLoaded] = useState(false);
  const { fetchLoginPageBranding } = useFetchLoginPageBranding();

  useEffect(() => {
    initBranding();
  }, []);

  async function initBranding() {
    const res = await fetchLoginPageBranding();

    if (!res.Success) {
      console.warn(res.ErrorMessage);
    }

    setBrandingValues({
      primaryColor: res.BrandingDetails.PrimaryColor,
      secondaryColor: res.BrandingDetails.SecondaryColor,
      logo: res.Logo,
      appTitle: res.AppTitle,
      appFavicon: res.Favicon,
    });

    setBrandingLoaded(true);
  }

  return (
    <div className={styles.loginContainer}>
      {brandingLoaded && (
        <Box flx="col" ai="center">
          {logo ? (
            <div className={styles.logoContainer}>
              <img
                src={logo}
                style={{
                  maxWidth: '175px',
                  maxHeight: '100px',
                  width: 'auto',
                  height: 'auto',
                  minHeight: '50px', // Prevents collapsing to 0x0
                  objectFit: 'contain',
                }}
                alt="Logo"
              />
            </div>
          ) : (
            <Link to={{ pathname: 'https://vopay.com' }} target="_blank">
              <Icon icon="vLogoText" width="100px" height="100px" />
            </Link>
          )}

          <div className={styles.formContainer}>
            <Box mt="lg" flx="col" ai="center" pe="xmd" ps="xmd" pt="md" pb="md" boundary="border" height="auto">
              <LoginRoutes />
            </Box>
          </div>
        </Box>
      )}
    </div>
  );
};

export default withRouter(Login);
